<div
  class="form-input"
  (clickElsewhere)="closeTooltip()"
  [class.whiteColor]="whiteColor"
  [class.employerStage]="employerStage"
  [attr.data-cy]="cyName"
  >
  <div class="form-input__header level">
    <div class="level-left" (click)="closeTooltip()">
      <label class="form-input__label" [class.center]="centerLabel" [class.sm]="smLabel">
        <span class="form-input__label-tx">{{ label | translate }}</span>
      </label>
    </div>
    @if (message) {
      <app-more-info-tooltip
        class="tooltipInInput"
        [message]="message"
        [isSmall]="true"
        [showText]="false"
        [isSmallIcon]="true"
        [additionalDeductions]="true"
        [tooltipInInput]=true
      ></app-more-info-tooltip>
    }
  </div>
  <div
    class="form-input__content"
    [class.disabled]="isDisabled"
    [class.active]="activeInput"
    [class.notEmpty]="inputChange"
    [class.error]="errors && errors.length"
    [class.warning]="warnings && warnings.length"
    [class.sm]="smLabel"
    >
    @if (noYear) {
      <input
        [placeholder]="placeholder | translate"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        (ngModelChange)="change($event)"
        [maxlength]="noYear ? 5 : 10"
        [attr.id]="currentInputId"
        [ngModel]="formatDate(model)"
        [class.form-input--error]="errors && errors.length"
        [class.form-input--warning]="warnings && warnings.length"
        [class.center]="centerTxtInput"
        [ngClass]="addClassB2B ? classB2B : ''"
        [class.isEditableSummaryEmployer]="isEditableSummaryEmployer"
        [dropSpecialCharacters]="false"
        [mask]="'d0/M0'"
        [disabled]="isDisabled"
        >
    }
    @if (!noYear) {
      <input
        [placeholder]="placeholder | translate"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        (ngModelChange)="change($event)"
        [maxlength]="noYear ? 5 : 10"
        [attr.id]="currentInputId"
        [ngModel]="formatDate(model)"
        [class.form-input--error]="errors && errors.length"
        [class.form-input--warning]="warnings && warnings.length"
        [class.center]="centerTxtInput"
        [ngClass]="addClassB2B ? classB2B : ''"
        [class.isEditableSummaryEmployer]="isEditableSummaryEmployer"
        [disabled]="isDisabled"
        >
    }
  </div>
  @if (errors && errors[0]) {
    <div class="form-input__error">{{ errors[0] }}</div>
  }
  @if ((!errors || !errors.length) && warnings) {
    <div class="form-input__warning">{{ warnings[0] }}</div>
  }
</div>
